<template>
  <div class="ol-folder-tab" />
</template>

<script>
export default {
  name: 'OlFolderTab'
}
</script>

<style lang="scss" scoped>

  .ol-folder-tab {
    width: 40%;
    /* top: -24px; */
    position: relative;
    height: 24px;
    border-top-right-radius: 16px;
  }

  .ol-folder-tab::after {
    content: " ";
    border: 1px solid #2c9b91;
    position: absolute;
    bottom: -12px;
    right: -20px;
    width: 32px;
    height: 32px;
    border-width: 0 0 12px 12px;
    border-bottom-left-radius: 32px;
  }

</style>
